import React from 'react';
import { Link } from 'react-router-dom'
import { Table, Tag, Space, Card } from 'antd';
import axios from '../services/axios'
import moment from 'moment'

interface IProps {
  pagination: {
    pageSize: Number,
    current: Number
  }
}


const Taux_jours = () => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [devises, setDevises] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 100
  });

  React.useEffect(() => {
    axios.get('/devises')
      .then(response => setDevises(response.data.filter((d: any) => d.code !== 'GNF')))
      .catch(() => {});
    fetchData({ pagination } as IProps);
  }, [])

  const getRandomuserParams = (params: any) => ({
    results: params.pagination.pageSize,
    page: params.pagination.current,
    ...params,
  });

  const columns = [
    ...devises.map((devise: any) => ({
      title: `1 ${devise.code}=>GNF`,
      dataIndex: ['taux', devise.code],
      key: `taux_${devise.code}`,
    })),
    {
      title: 'Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: string) => <a>{moment(text).format()}</a>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link to={`/add-taux-jour/edit/${record.id}`}>Editer</Link>
        </Space>
      ),
    },
  ];

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    fetchData({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters,
    });
  };

  const fetchData = (params: any) => {
    setLoading(true);
    axios.get('/taux-jours')
      .then(response => {
        const dataPagination = getRandomuserParams(params)
        
        setData(response.data);
        setLoading(false)
        setPagination({ ...dataPagination.pagination, total: 20 })
      });
  };


  return <>
    <Card size="small" title={<h4>La liste des Taux du jour</h4>} extra={<Link to="/add-taux-jours" className="btn btn-primary">Nouveau</Link>} >
      <Table
        columns={columns}
        rowKey={(record: any) => record.id}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </Card>
  </>;
}

export default Taux_jours;